<template>
    <div>
        <div class="bottom-line p-4 flex justify-between items-center">
            <p>
                Name
            </p>
            <p class="font-semibold">{{ $root.user.full_name }}</p>
        </div>
        <div class="bottom-line p-4 flex justify-between items-center">
            <p>
                Email
            </p>
            <p class="font-semibold">{{ $root.user.email }}</p>
        </div>
        <div class="p-4 flex justify-between items-center">
            <p class="mr-6">
                Password
            </p>
            <p class="font-semibold text-right">Created {{ $root.user.created_at | date('human') }}</p>
        </div>
    </div>
</template>

<script>
    export default {}
</script>